// extracted by mini-css-extract-plugin
module.exports = {"status_box":"_3Inzz","status_img":"ByreH","status_header":"_1tmSc","status_desc":"MMQIU"};